import React from "react";
import { Outlet } from "react-router-dom";
import ProtectedRoutesErrorContainer from "@/components/ui/protected-routes-error-container";
import { Footer, Header } from "@/features/main-layout";

const isStandalone = import.meta.env.VITE_STANDALONE !== "false";

export default function AppRoutesLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      {isStandalone && <Header />}
      <main
        className="grow"
        data-testid="homepage-container"
      >
        <ProtectedRoutesErrorContainer>
          <Outlet />
        </ProtectedRoutesErrorContainer>
      </main>
      {isStandalone && <Footer />}
    </div>
  );
}
